import dayjs from 'dayjs';
import Commons from '../../../../Services/Common/Common';

export const M_PER_CUSTOM_01_Schema = {
  fields: {
    baseInfo: {
      pmCd: { initial: '', label: '허가서코드' },
      constructionNm: {
        initial: '',
        label: '공사 업체명',
        required: 'Y',
        group: 'construction',
        variants: ['CUSTOM', 'BASIC'],
        step: 1,
        order: 40,
        placeholder: '공사 업체명을 입력하세요',
        maxLength: 100,
      },
      siteName: {
        initial: '',
        label: '현장명',
        required: 'Y',
        group: 'construction',
        variants: ['CUSTOM'],
        step: 1,
        order: 10,
        placeholder: '현장명을 입력하세요',
        maxLength: 256,
      },
      siteManager: {
        initial: '',
        label: '현장 책임자',
        required: 'Y',
        group: 'construction',
        variants: ['CUSTOM', 'BASIC'],
        step: 1,
        order: 50,
        placeholder: '현장 책임자를 입력하세요',
        maxLength: 100,
      },
      sitePhone: {
        initial: '',
        label: '연락처',
        required: 'Y',
        group: 'construction',
        variants: ['CUSTOM', 'BASIC'],
        step: 1,
        order: 60,
        placeholder: '연락처를 입력하세요',
        maxLength: 20,
        inputMode: 'numeric',
        format: 'phone',
      },
      workStartDate: {
        initial: dayjs()
          .set('hour', 9)
          .startOf('hour')
          .format('YYYY-MM-DD HH:mm'),
        label: '작업 시작일시',
        required: 'Y',
        group: 'work',
        variants: ['CUSTOM', 'BASIC'],
        step: 1,
        order: 10,
        type: 'datetime',
        role: 'workStartDate',
      },
      workEndDate: {
        initial: dayjs()
          .set('hour', 18)
          .startOf('hour')
          .format('YYYY-MM-DD HH:mm'),
        label: '작업 종료일시',
        required: 'Y',
        group: 'work',
        variants: ['CUSTOM', 'BASIC'],
        step: 1,
        order: 20,
        type: 'datetime',
        role: 'workEndDate',
      },
      workDetail: {
        initial: '',
        label: '작업 내용',
        required: 'Y',
        group: 'work',
        variants: ['CUSTOM', 'BASIC'],
        step: 1,
        order: 40,
        placeholder: '작업 내용을 입력하세요',
        labelByVariant: { CUSTOM: '세부작업내용' },
        placeholderByVariant: { CUSTOM: '세부작업내용을 입력하세요' },
        maxLength: 256,
      },
      workPlace: {
        initial: '',
        label: '작업 장소',
        required: 'Y',
        group: 'work',
        variants: ['CUSTOM', 'BASIC'],
        step: 1,
        order: 50,
        placeholder: '작업 장소를 입력하세요',
        labelByVariant: { CUSTOM: '작업/공사위치' },
        placeholderByVariant: { CUSTOM: '작업/공사위치를 입력하세요' },
        maxLength: 100,
      },
      workMemberNo: {
        initial: '',
        label: '작업 인원수',
        required: 'Y',
        group: 'work',
        variants: ['CUSTOM', 'BASIC'],
        step: 1,
        order: 60,
        placeholder: '작업 인원수를 입력하세요',
        labelByVariant: { CUSTOM: '투입인원' },
        placeholderByVariant: { CUSTOM: '투입 인원을 입력하세요' },
        maxLength: 11,
        inputMode: 'numeric',
        format: 'numeric',
      },
      workType: {
        initial: '',
        label: '작업종류',
        required: 'Y',
        group: 'work',
        variants: ['CUSTOM', 'BASIC'],
        step: 2,
        order: 999,
      },
      workItemId: {
        initial: '',
        label: '작업종류아이템ID',
        required: 'Y',
        group: 'work',
        variants: ['CUSTOM', 'BASIC'],
        step: 2,
        order: 1000,
      },
      permissionDate: {
        initial: dayjs().format('YYYY-MM-DD'),
        label: '허가일자',
        required: 'Y',
        group: 'construction',
        variants: ['CUSTOM'],
        step: 1,
        order: 20,
        placeholder: '허가일자를 입력하세요',
        type: 'date',
        role: 'permissionDate',
      },
      permissionNo: {
        initial: '',
        label: '허가번호',
        required: 'Y',
        group: 'construction',
        variants: ['CUSTOM'],
        step: 1,
        order: 30,
        placeholder: '허가번호를 입력하세요',
        maxLength: 20,
        inputMode: 'numeric',
        format: 'numeric',
      },
      planNum: {
        initial: '',
        label: '계획인원',
        required: 'Y',
        group: 'work',
        variants: ['CUSTOM'],
        step: 1,
        order: 30,
        placeholder: '계획인원을 입력하세요',
        maxLength: 11,
        inputMode: 'numeric',
        format: 'numeric',
      },
      guardian: {
        initial: '',
        label:
          '감시인(밀폐, 화기)\n최대작업 높이(고소)\n 중량(중량물)\n하역운반기계(운반로)',
        group: 'work',
        variants: ['CUSTOM'],
        step: 1,
        order: 70,
        placeholder: '작업허가서 종류에 해당하는 사항을 입력하세요',
        maxLength: 100,
      },
      preventiveMeasures: {
        initial: '',
        label: '예방대책',
        group: 'work',
        variants: ['CUSTOM'],
        step: 1,
        order: 80,
        placeholder: '예방대책을 입력하세요',
      },
      etcContent: {
        initial: '',
        label: '기타 특별사항',
        group: 'work',
        variants: ['CUSTOM'],
        step: 1,
        order: 90,
        placeholder: '기타 특별사항을 입력하세요',
      },
      workList: {
        initial: '',
        label: '작업자 명단',
        group: 'work',
        variants: ['CUSTOM'],
        step: 1,
        order: 100,
        placeholder: '작업자 명단을 입력하세요',
        type: 'workerList',
        maxLength: 255,
        role: 'workList',
      },
    },
    departmentInfo: {
      depCd: { initial: '', label: '부서코드' },
      depNm: { initial: '', label: '부서명' },
      headId: { initial: '', label: '결재승인자ID' },
      headNm: { initial: '', label: '결재승인자명' },
    },

    codeInfo: {
      workTypes: { initial: [], label: '작업종류목록' },
      risks: {
        initial: [],
        label: '위험요인목록',
        codeKey: 'riskCode',
        nameKey: 'riskNm',
      },
      equips: {
        initial: [],
        label: '보호구목록',
        codeKey: 'workEquipCode',
        nameKey: 'workEquipNm',
      },
      preparations: {
        initial: [],
        label: '준비사항목록',
        codeKey: 'preparationCode',
        nameKey: 'preparationNm',
      },
    },
  },

  mapper: {
    search1: {
      CustCd: (context) => Commons.EncryptAES(context.userInfo?.custCd),
    },
    search2: {
      WorkItemId: (context) => Commons.EncryptAES(context.workItemId),
    },
    search3: {
      PmCd: (context) => Commons.EncryptAES(context.pmCd),
      UserId: (context) => context.userInfo?.userid,
    },
    search4: {
      CustCd: (context) => Commons.EncryptAES(context.userInfo?.custCd),
      UserId: (context) => context.userInfo?.userid,
    },
    save1: {
      PmCd: (context) => Commons.EncryptAES(context.baseInfo.pmCd || ''),
      CustCd: (context) => Commons.EncryptAES(context.userInfo?.custCd),
      DepCd: (context) => Commons.EncryptAES(context.userInfo?.depCd),
      UserId: (context) => context.userInfo?.userid,
      ConstructionNm: (context) =>
        Commons.EncryptAES(context.baseInfo.constructionNm),
      SiteNm: (context) => Commons.EncryptAES(context.baseInfo.siteName),
      SiteManager: (context) =>
        Commons.EncryptAES(context.baseInfo.siteManager),
      SitePhone: (context) => Commons.EncryptAES(context.baseInfo.sitePhone),
      WorkStartDate: (context) => context.baseInfo.workStartDate,
      WorkEndDate: (context) => context.baseInfo.workEndDate,
      WorkDetail: (context) => Commons.EncryptAES(context.baseInfo.workDetail),
      WorkPlace: (context) => Commons.EncryptAES(context.baseInfo.workPlace),
      WorkMemberNo: (context) =>
        Commons.EncryptAES(context.baseInfo.workMemberNo),
      WorkType: (context) => Commons.EncryptAES(context.baseInfo.workType),
      PermissionDate: (context) => context.baseInfo.permissionDate,
      PermissionNo: (context) =>
        Commons.EncryptAES(context.baseInfo.permissionNo),
      PlanNum: (context) => Commons.EncryptAES(context.baseInfo.planNum),
      Guardian: (context) => Commons.EncryptAES(context.baseInfo.guardian),
      PreventiveMeasures: (context) =>
        Commons.EncryptAES(context.baseInfo.preventiveMeasures),
      EtcContent: (context) => Commons.EncryptAES(context.baseInfo.etcContent),
      WorkList: (context) => Commons.EncryptAES(context.baseInfo.workList),
      RiskCodes: (context) =>
        Commons.EncryptAES(
          context.codeInfo.risks
            ?.filter((r) => r.itemCheck === 'Y')
            .map((r) => String(r.riskCode || ''))
            .join(',') || ''
        ),
      WorkEquipCodes: (context) =>
        Commons.EncryptAES(
          context.codeInfo.equips
            ?.filter((e) => e.itemCheck === 'Y')
            .map((e) => String(e.workEquipCode || ''))
            .join(',') || ''
        ),
      PreparationCodes: (context) =>
        Commons.EncryptAES(
          context.codeInfo.preparations
            ?.filter((p) => p.itemCheck === 'Y')
            .map((p) => String(p.preparationCode || ''))
            .join(',') || ''
        ),
      SmId: (context) => Commons.EncryptAES(context.smId),
    },
  },
};
